import { CurrencyCode } from './currency'
import { GamNetworkConfig } from './gam/adx'
import { Feature } from './rolesAndFeatures'
import { Timezone } from './timezone'

export type ScopeId = string

export interface Scope {
  id: string
  name: string
  currencyCode: CurrencyCode
  enabled: boolean
  pbjs: string
  requestMarketplaceDate?: number
  /**
   * What this scope has been sold, whoever is looking at it.
   *
   * Distinct from `User.features`, which for a Pubstack user is synthesised as *every* feature so staff
   * can operate any account — true of the viewer, not of the customer. Anything answering "does this
   * account have Node" has to read this instead, or it reads as yes for every Pubstack user.
   *
   * Distinct from `onboardedFeatures` too: that is provisioning state and only exists for the few
   * features that need it (`pbsStandalone`, `pbstckBidder`, `sparkForPub`), so it cannot answer for
   * `adstack`, `inapp` or `amp`.
   */
  accessFeatures?: Feature[]
  gamKeyNamesForPrebid: string[]
  timezone: Timezone
  mfaRequired: boolean
  disableCanAddMember?: boolean
  onboardedFeatures?: string[]
}

export interface AdminScope extends Scope {
  features?: Feature[]
  viewabilityEnabled: boolean
  refreshEnabled: boolean
  standaloneUserSessionEnabled: boolean
  sessionTrackingDisabled: boolean
  smartEnabled: boolean
  coreWebVitalsEnabled: boolean
  userAccessFeatures: string[]
  customerId?: string
}

export interface AdminScopeWithGamNetwork extends AdminScope {
  gamNetworkConfigs: GamNetworkConfig[]
}

export const EMPTY_ADMIN_SCOPE: AdminScope = {
  id: '',
  name: '',
  enabled: false,
  pbjs: '',
  currencyCode: 'EUR',
  gamKeyNamesForPrebid: [],
  features: [],
  viewabilityEnabled: false,
  refreshEnabled: false,
  standaloneUserSessionEnabled: false,
  sessionTrackingDisabled: false,
  smartEnabled: false,
  coreWebVitalsEnabled: false,
  timezone: 'Europe/Paris',
  mfaRequired: false,
  userAccessFeatures: [],
}

export type AdminScopeDataIngestionFlags = Pick<
  AdminScope,
  'viewabilityEnabled' | 'refreshEnabled' | 'standaloneUserSessionEnabled' | 'smartEnabled' | 'sessionTrackingDisabled' | 'coreWebVitalsEnabled'
>
